import React, { useEffect, useState } from 'react';

interface ExtraWarningProps {
    message: string;
    roomNumber?: string;
    onDismiss: () => void;
    autoDismissMs?: number;
}

const ExtraWarning: React.FC<ExtraWarningProps> = ({
    message, roomNumber, onDismiss, autoDismissMs = 4000,
}) => {
    const [visible, setVisible] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setVisible(false);
            setTimeout(onDismiss, 300);
        }, autoDismissMs);
        return () => clearTimeout(timer);
    }, [autoDismissMs, onDismiss]);

    return (
        <div style={{
            position: 'fixed', top: 20, right: 20, zIndex: 10000,
            backgroundColor: '#FFF6ED', border: '1px solid #FEDF89',
            borderRadius: 8, padding: '12px 16px', maxWidth: 360,
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            opacity: visible ? 1 : 0, transition: 'opacity 0.3s ease',
            display: 'flex', gap: 10, alignItems: 'flex-start',
        }}>
            <span style={{ fontSize: 20, lineHeight: '20px' }}>&#9888;</span>
            <div style={{ flex: 1 }}>
                <div style={{ fontSize: 13, fontWeight: 600, color: '#B93815', marginBottom: 2 }}>
                    Extra Charge
                    {roomNumber && <span style={{ fontWeight: 400 }}> - Room {roomNumber}</span>}
                </div>
                <div style={{ fontSize: 12, color: '#93370D' }}>
                    {message}
                </div>
            </div>
            <button
                onClick={() => { setVisible(false); setTimeout(onDismiss, 300); }}
                style={{
                    background: 'none', border: 'none', cursor: 'pointer',
                    color: '#B93815', fontSize: 16, padding: 0, lineHeight: '16px',
                }}
            >
                &times;
            </button>
        </div>
    );
};

export default ExtraWarning;
